<template>
  <modal-padrao
    ref="modal"
    max-width="900px"
    :titulo="$t('modulos.calibracao.anexos.titulo_modal')"
    :titulo-ok="$t('geral.botoes.salvar')"
    @ok="salvar"
  >
    <v-form
      ref="form"
      class="row"
    >
      <input-text
        v-model="form.descricao"
        class="col-12"
        :label="$t('modulos.calibracao.anexos.formulario.descricao')"
        obrigatorio
      />

      <input-select
        id="dados-tabela"
        v-model="form.faixasTabelas"
        class="col-8"
        :label="$t('modulos.calibracao.formulario.faixa_tabela')"
        :placeholder="$t('geral.inputs.selecione')"
        :options="opcoesTabelas"
      />

      <input-radio
        v-model="form.flagPermiteApresentarCertificado"
        class="col-4"
        :divider="false"
        :options="opcoes.boleano"
        :label="$t('modulos.calibracao.formulario.permitir_apresentar_certificado')"
      />

      <input-file-drag-n-drop
        v-model="form.arquivo"
        class="col-12"
        :multiplos="false"
        :tem-tamanho-maximo="true"
        :maximo-tamanho="tamanhoMaximoAnexo"
      />
    </v-form>
  </modal-padrao>
</template>
<script>
import helpers from '@/common/utils/helpers';
import CalibracaoService from '@common/services/cadastros/CalibracaoService';
import _ from 'lodash';

export default {
  data: function () {
    return {
      form: {
        calibracaoId: '',
        descricao: '',
        arquivo: [],
        tabelas: [],
        tabelaId: '',
        calibracaoFaixaId: '',
        faixasTabelas: {
          faixaId: '',
          tabelaId: '',
        },
        tabelaSelecionada: {
          id: null,
        },
        flagPermiteApresentarCertificado: false,
      },
      opcoesTabelas: [],
      opcoes: {
        boleano: helpers.BoleanoEnum,
      },
      valido: false,
      tamanhoMaximoAnexo: 2097152,
    };
  },
  methods: {
    abrirModal: function (calibracaoId, faixasTabelas = null) {
      this.form = {
        calibracaoId: '',
        descricao: '',
        arquivo: [],
        tabelas: [],
        tabelaId: '',
        calibracaoFaixaId: '',
        faixasTabelas: {
          faixaId: '',
          tabelaId: '',
        },
        tabelaSelecionada: {
          id: null,
        },
        flagPermiteApresentarCertificado: false,
      };
      this.form.calibracaoId = calibracaoId;
      this.$refs.modal.abrirModal();
      this.buscarTabelas(this.form.calibracaoId, faixasTabelas);
    },
    salvar: function () {
      if (this.$refs.form) this.valido = this.$refs.form.validate();
      let form = _.cloneDeep(this.form);
      if (form.arquivo.length == 0 || !this.valido) return;
      form.nomeArquivo = this.form.arquivo[0].nome;
      form.extensaoArquivo = this.form.arquivo[0].extensao;
      form.arquivo = this.form.arquivo[0].base64;
      form.tabelaId = this.form.faixasTabelas.tabelaId;
      form.calibracaoFaixaId = this.form.faixasTabelas.faixaId;

      this.$store.dispatch('Layout/iniciarCarregamento');

      CalibracaoService.salvarAnexo(form.calibracaoId, form)
        .then(() => {
          this.toastSucesso(this.$t(`modulos.calibracao.anexos.anexo_sucesso`));
          this.$refs.modal.fecharModal();
          this.$emit('listar');
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscarTabelas: async function (calibracaoId, faixasTabelas) {
      this.$store.dispatch('Layout/iniciarCarregamento');
      await CalibracaoService.buscarTabelas(calibracaoId)
        .then((res) => {
          this.form.tabelas = res.data.map((el) => {
            el.id = el.identificadorTabela;
            return el;
          });

          if (faixasTabelas) {
            this.form.faixasTabelas = faixasTabelas;
          } else {
            this.form.faixasTabelas = {
              faixaId: '',
              tabelaId: '',
            };
          }

          this.obterOpcoesTabelas();
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    obterOpcoesTabelas: function () {
      this.opcoesTabelas = this.form.tabelas.map((el) => {
        const faixa = el.faixasTabelas.find((faixa) => faixa.tabelaId === el.tabela.id);

        return {
          value: faixa,
          text: `${faixa.nomeFaixa} | ${el.procedimentoEletronico.nome} - ${el.tabela.nome}${
            el.unidadeMedida
              ? ` - (${helpers.formatarNumeroComPrecisao(
                  el.amplitudeMinima
                )} a ${helpers.formatarNumeroComPrecisao(el.amplitudeMaxima)}) ${
                  el.unidadeMedida.nome
                }`
              : ''
          }`,
        };
      });
    },
  },
};
</script>
